import Vue from 'vue';
import { notificationExposer } from '@pirates/not-morty-biz';
import { ActionContext, ActionTree, Module, MutationTree } from 'vuex';
import { NotificationState } from './notification.model';
import { t } from '@/utils/translation';

class Notifications implements Module<NotificationState, any> {
  public state: NotificationState = {
    customerNotifications: undefined,
  };

  public namespaced: boolean = true;
  public actions = {
    async getCustomerNotifications(store: ActionContext<NotificationState, any>) {
      try {
        const notifications = await notificationExposer.getCustomerNotifications();

        store.commit('SET_CUSTOMER_NOTIFICATION', notifications);
      } catch (_) {
        Vue.utils.$toast(t('error_msg_unknown'), 'error');
      }
    },
  } as ActionTree<NotificationState, any>;

  public mutations = {
    SET_CUSTOMER_NOTIFICATION(state: NotificationState, payload) {
      state.customerNotifications = payload;
    },
  } as MutationTree<NotificationState>;
}

export default new Notifications();
